/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconSquareRoundedLetterF = createReactComponent("outline", "square-rounded-letter-f", "IconSquareRoundedLetterF", [["path", { "d": "M10 12h3", "key": "svg-0" }], ["path", { "d": "M14 8h-4v8", "key": "svg-1" }], ["path", { "d": "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z", "key": "svg-2" }]]);

export { IconSquareRoundedLetterF as default };
//# sourceMappingURL=IconSquareRoundedLetterF.mjs.map
